//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import structuredClone from '@ungap/structured-clone';

export default {
  props: ['competition', 'region', 'sport', 'date', 'isLive', 'type', 'mode', 'title', 'title-icon', 'hideSubtitles', 'hideEmpty'],
  data() {
    return {
      competitions: [],
      events: [],
      defaultFilter: null,
      selectedFilter: null,
      filters: [],
      updates: 0,
      currentCols: 3,
      marketsLoading: false,
      loading: true
    }
  },
  computed: {
    cols() {
      if( _.get(this.myFilter, 'cols'))
        return _.get(this.myFilter, 'cols');
            
      if( _.get(this.competitions, '[0].default_cols') )
        return _.get(this.competitions, '[0].default_cols')
            
      if( _.get(this.competitions, '[0].events[0].markets.default.outcomes') )
        return _.size(_.get(this.competitions, '[0].events[0].markets.default.outcomes'))
      
      return 3
    },
    myFilter() {
      return _.find(this.filters, {code: this.selectedFilter});
    },
    isVisible() {
      if (this.hideEmpty && this.competitions && this.competitions.length === 0) {
        return false
      }
      return true
    },
    hash() {
      let params = {
        competition: this.competition,
        sport: this.sport,
        isLive: this.isLive,
        type: this.type,
        mode: this.mode,
        lang: this.lang
      }
      params = _.omitBy(params, _.isNil)
      return new URLSearchParams(params).toString()
    }
  },
  watch: {
    appState: function (active) {
      if(active) {
        this.fetchEvents()
      }
    },
    hash: {
      handler: function (newVal, oldVal) {
        this.loading = true
        //console.log('events_widget', newVal, oldVal );
        if (tock.active('events_widget' + oldVal)) {
          //console.log('events_widget', newVal, oldVal );
          this.currentEvents = []
          this.loading = true
          tock.clear('events_widget' + oldVal)
        }
        this.initInterval()
      }
    }
  },
  created() {
    this._markets = {}
    this.competitions = _.get(this.$store.state, 'games.eventsInfo')
  },
  mounted() {
    this.currentEvents = []
    this.initInterval()
    if (this.competitions.length > 0) {
      this.loading = false
    } else {
      this.loading = true
    }    
  },
  beforeDestroy: function () {
    console.log('CHANGE clear', this.type, this.sport, this.hash);
    tock.clear('events_widget' + this.hash)
    emitter.off('events')
  },
  methods: {
    async initInterval() {
      await this.fetchEvents()
      if (tock.active('events_widget' + this.hash)) {
        tock.clear('events_widget' + this.hash)
      }
      emitter.off('events')
      emitter.on('events', (e) => {
        if (_.size(_.intersection(e, this.currentEvents))) {
          if (!this.loading) {
            console.log('CHANGE emitter', this.type, this.sport);
            this.fetchEvents()
          }
        }
      })

      tock.setInterval(
        'events_widget' + this.hash,
        () => {
          console.log('CHANGE setInterval', this.type, this.sport, this.hash);
          this.fetchEvents()
        },
        30 * 1000
      )
    },
    async fetchMarkets() {
      let params = {}
      params['market_code'] = _.clone(this.selectedFilter)
      params['events'] = _.join(this.currentEvents, ',')
      params['lang'] = this.lang
      params['sport'] = this.sport
      if (this.type == 'live') params['live'] = true
      params['bookmaker'] = this.$config.BOOKMAKER
 
      const eventMarkets = await this.$api().$get('/rpc/v1/events/selections', { params: params });

      _.forEach(this.competitions, (competition, competition_i) => {
        competition.events = _.forEach(competition.events, (event, event_i) => {
          _.set(this._markets, event.id+'.'+params.market_code, _.get(eventMarkets.markets, event.id));
        });
      });

      let competitions = structuredClone(this.competitions)
      competitions = _.map(competitions, (competition) => {
        competition.events = _.map(competition.events, (event) => {
          event.markets = _.merge(_.get(this._markets, event.id, {}), event.markets);
          return event
        });
        return competition
      });

      console.log('competitions', competitions)
      this.competitions = structuredClone(competitions)
      this.marketsLoading = false;
      this.currentCols = _.get(eventMarkets, 'cols', 3);
    },
    async fetchEvents() {
      let params = {}
      if (this.date) params['date'] = this.date
      if (this.sport) params['sport'] = this.sport
      if (this.region) params['region'] = this.region
      if (this.competition) params['competition'] = this.competition
      if (this.type) params['type'] = this.type
      if (this.type == 'live') params['live'] = true
      if (this.updates === 0) params['_cached'] = true
      params['key'] = 'market_type'
      params['mode'] = this.mode
      params['lang'] = this.lang
      params['country'] = this.country
      params['bookmaker'] = this.$config.BOOKMAKER

      /*
      const response = await this.$api().$get('/rpc/v1/eventstest', { params: params });

      console.log('response', response);
      this.setResponse(response)
      if(this.selectedFilter != 'default') {
        this.fetchMarkets()
      }
      this.updates++
      */
      await this.$sportify().sportsbook.getEvents(params, (response) => {
        this.setResponse(response)
        if(this.selectedFilter != 'default') {
          this.fetchMarkets()
        }
        this.updates++
      })

      //console.log('fetchEvents', new URLSearchParams(params).toString())
      //let hash = simpleHash(JSON.stringify(params))
      //this.$socket().send('find', 'events', params, (error, response) => {
      //this.setResponse(response)
      //})
    },
    async changeFilter(filter) {
      this.marketsLoading = true;
      console.log('changeFilter', this.selectedFilter)
      await this.fetchMarkets();
    },
    async setResponse(response) {
      this.defaultFilter = response.default_market_type
      if (!this.selectedFilter) {
        this.selectedFilter = response.default_market_type
      }
      if (!_.includes(_.map(response.market_filters, 'code'), this.selectedFilter)) {
        this.selectedFilter = response.default_market_type
      }
      this.filters = response.market_filters
      //let competitions = response.competitions

      let competitions = _.map(response.competitions, (competition) => {
        competition.events = _.map(competition.events, (event) => {
          event.markets = _.merge(_.get(this._markets, event.id, {}), event.markets);
          return event
        });
        return competition
      });

      this.competitions = _.cloneDeep(competitions)
      this.currentEvents = _.chain(response.competitions).flatMap('events').map('id').value()
      this.$store.commit('games/setEventsInfo', [])
      this.loading = false
      emitter.emit('events_loaded')

    }
  }
}
